import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';


import { CatalogProduct } from './get-storefront-catalog';
import { Category } from '../../models/categories/category';

@Injectable({
  providedIn: 'root'
})
export class GetFullCatalogGQL extends Query<GetFullCatalogGQLResponse, GetFullCatalogGQLVariables> {
  document = gql`
  query getStorefrontCatalog($storefrontId: ID) {
    storefronts(storefrontIds: [$storefrontId]) {
      catalog {
        catalogId
        name
        categories {
          categoryId
          name
          position
          isAffiliate
        }
        products {
          productId
          name
          sku
          msrp {
            amount
          }
          price {
            amount
          }
          categories {
            name
            position
          }
        }
      }
    }
  }
  `;
}

interface GetFullCatalogGQLResponse {
  storefronts: { catalog: Catalog }[];
}

interface GetFullCatalogGQLVariables {
  storefrontId: string;
}

export interface Catalog {
  catalogId: string;
  name: string;
  categories: Category[];
  products: CatalogProduct[];
}
